import { Avatar, Space, Tooltip } from "antd";
import { FONT } from "constants/index";
import { ChartColumnStacked, UserRound } from "lucide-react";

export const ColumnsUser = () => {
  const table = [
    {
      title: "Foto",
      dataIndex: "image",
      width: "15%",
      render: (text, row) => {
        return (
          <Avatar src={row.img} icon={<UserRound size={50} />} size={50} />
        );
      },
    },
    {
      title: "Nome",
      dataIndex: "name",
      textWrap: "word-break",
      ellipsis: true,
      width: "15%",
    },
  ];

  const tableDefault = [
    {
      title: "E-mail",
      dataIndex: "email",
      textWrap: "word-break",
      width: "25%",
      ellipsis: true,
    },
    {
      title: "Última Planificação",
      dataIndex: "lastPlanning",
      textWrap: "word-break",
      width: "15%",
      ellipsis: true,
    },
  ];

  table.push(...tableDefault);

  table.push({
    title: "Ações",
    dataIndex: "action",
    width: "25%",
    render: (text, row) => {
      return (
        <Space size="middle">
          {row.detail && (
            <Tooltip style={{ fontFamily: FONT }} title="Ver Treino">
              <ChartColumnStacked
                onClick={() => row.detail(row)}
                size={22}
                style={{ cursor: "pointer", color: "#2980B9" }}
              />
            </Tooltip>
          )}
        </Space>
      );
    },
  });
  return table;
};

export const ColumnsUserBoot = () => {
  const table = [
    {
      title: "Foto",
      dataIndex: "image",
      width: "15%",
      render: (text, row) => {
        return (
          <Avatar src={row.img} icon={<UserRound size={50} />} size={50} />
        );
      },
    },
    {
      title: "Nome",
      dataIndex: "name",
      textWrap: "word-break",
      ellipsis: true,
      width: "15%",
    },
  ];

  const tableDefault = [
    {
      title: "E-mail",
      dataIndex: "email",
      textWrap: "word-break",
      width: "25%",
      ellipsis: true,
    },
  ];

  table.push(...tableDefault);

  table.push({
    title: "Ações",
    dataIndex: "action",
    width: "25%",
    render: (text, row) => {
      return (
        <Space size="middle">
          {row.detail && (
            <Tooltip style={{ fontFamily: FONT }} title="Progresso">
              <ChartColumnStacked
                onClick={() => row.detail(row)}
                size={22}
                style={{ cursor: "pointer", color: "#2980B9" }}
              />
            </Tooltip>
          )}
        </Space>
      );
    },
  });
  return table;
};
